import React, { useState, useEffect } from "react";
import Button from "../CustomButtons/Button.jsx";
import ViewFiltersModal from "./ViewFiltersModal";
import { loadHiddenColumns } from "./viewFiltersApi";

const LOCKED_ACCESSORS = ['actions'];

const buildKey = (moduleName, tab) => (tab ? `${moduleName}:${tab}` : moduleName);

export const useViewFilters = (moduleName, columns, tab) => {
    const [hidden, setHidden] = useState([]);
    const [open, setOpen] = useState(false);
    const key = buildKey(moduleName, tab);

    useEffect(() => {
        let cancelled = false;
        loadHiddenColumns(key).then((arr) => {
            if (cancelled) return;
            const sanitized = Array.isArray(arr)
                ? arr.filter(a => LOCKED_ACCESSORS.indexOf(a) === -1)
                : [];
            setHidden(sanitized);
        });
        return () => { cancelled = true; };
    }, [key]);

    const filteredColumns = Array.isArray(columns)
        ? columns.filter(c => hidden.indexOf(c.accessor) === -1)
        : columns;

    const viewFiltersButton = (
        <>
            <Button color="white" onClick={() => setOpen(true)}>
                <i className="fa fa-columns" style={{ marginRight: 6 }} />
                COLUMNS
            </Button>
            {open && (
                <ViewFiltersModal
                    open={open}
                    close={() => setOpen(false)}
                    moduleName={key}
                    availableColumns={columns || []}
                    onSaved={setHidden}
                />
            )}
        </>
    );

    return { hiddenColumns: hidden, filteredColumns, viewFiltersButton };
};

export const ViewFiltersButton = ({ moduleName, columns, tab, onHiddenChange }) => {
    const { hiddenColumns, viewFiltersButton } = useViewFilters(moduleName, columns, tab);
    useEffect(() => {
        if (typeof onHiddenChange === 'function') onHiddenChange(hiddenColumns);
    }, [hiddenColumns]);
    return viewFiltersButton;
};
